import { useEffect } from "react";

const ExternalScripts = () => {
  useEffect(() => {
    const scriptUrls = [
      "/js/jquery.js",
      "/js/popper.min.js",
      "/js/bootstrap.min.js",
      "/js/jquery.fancybox.js",
      "/js/wow.js",
      "/js/appear.js",
      "/js/mixitup.js",
      "/js/knob.js",
      "./js/main.js"
    ];

    const scripts = [];

    scriptUrls.forEach((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = false;
      document.body.appendChild(script);
      scripts.push(script);
    });

    return () => {
      scripts.forEach((script) => {
        document.body.removeChild(script);
      });
    };
  }, []);

  return null;
};

export default ExternalScripts;
